// extracted by mini-css-extract-plugin
export default {"wrapper":"DesktopTitle_wrapper__7IXuu","picker":"DesktopTitle_picker__iHC1Q"};